import React from "react"
import PropTypes from "prop-types"
import { graphql, Link,StaticQuery } from "gatsby"
import GuideStarComponent from "./guideStarComponent2020"

const GuideStarComponentRows = ({Product,Stars,Year}) => (
  <StaticQuery
    query={graphql`
    {
      allBilforsikring2020Csv(sort: {fields: Provider, order: ASC}){
        edges {
          node{
            Provider
            Product
            Defaqto_Stjerne
          }
        }
      }
      allReiseforsikring2020Csv(sort: {fields: Provider, order: ASC}){
        edges {
          node{
            Provider
            Product
            Defaqto_Stjerne
          }
        }
      }
      allHusforsikring2020Csv(sort: {fields: Provider, order: ASC}){
        edges {
          node{
            Provider
            Product
            Defaqto_Stjerne
          }
        }
      }
      allInnboforsikring2020Csv(sort: {fields: Provider, order: ASC}){
        edges {
          node{
            Provider
            Product
            Defaqto_Stjerne
          }
        }
      }
      allBarneforsikring2020Csv(sort: {fields: Provider, order: ASC}){
        edges {
          node{
            Provider
            Product
            Defaqto_Stjerne
          }
        }
      }
      allTurbatforsikring2020Csv(sort: {fields: Provider, order: ASC}){
        edges {
          node{
            Provider
            Product
            Defaqto_Stjerne
          }
        }
      }
      allFritidsbatforsikring2020Csv(sort: {fields: Provider, order: ASC}){
        edges {
          node{
            Provider
            Product
            Defaqto_Stjerne
          }
        }
      }            
    }
    
    `}
    render={data => (
    <div className="moto-widget moto-widget-row moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" data-grid-type="sm" data-widget="row" data-spacing="aaaa" style={{}} data-bg-position="left top" data-draggable-disabled>
      <div className="container-fluid">
        <div className="row" data-container="container">
          {Product === "bil" && data.allBilforsikring2020Csv.edges.map(({node: forsikring,i}) => (
            <>{forsikring.Defaqto_Stjerne === Stars.toString() && <GuideStarComponent key={i} Section={Product} Year={Year} Product={forsikring.Product} Provider={forsikring.Provider} Stars={forsikring.Defaqto_Stjerne}/>}</>
          ))}
          {Product === "reise" && data.allReiseforsikring2020Csv.edges.map(({node: forsikring,i}) => (
          <>{forsikring.Defaqto_Stjerne === Stars.toString() && <GuideStarComponent key={i} Section={Product} Year={Year} Product={forsikring.Product} Provider={forsikring.Provider} Stars={forsikring.Defaqto_Stjerne}/>}</>
          ))}
          {Product === "hus" && data.allHusforsikring2020Csv.edges.map(({node: forsikring,i}) => (
            <>{forsikring.Defaqto_Stjerne === Stars.toString() && <GuideStarComponent key={i} Section={Product} Year={Year} Product={forsikring.Product} Provider={forsikring.Provider} Stars={forsikring.Defaqto_Stjerne}/>}</>
          ))}
          {Product === "innbo" && data.allInnboforsikring2020Csv.edges.map(({node: forsikring,i}) => (
            <>{forsikring.Defaqto_Stjerne === Stars.toString() && <GuideStarComponent key={i} Section={Product} Year={Year} Product={forsikring.Product} Provider={forsikring.Provider} Stars={forsikring.Defaqto_Stjerne}/>}</>
          ))}
          {Product === "barn" && data.allBarneforsikring2020Csv.edges.map(({node: forsikring,i}) => (
            <>{forsikring.Defaqto_Stjerne === Stars.toString() && <GuideStarComponent key={i} Section={Product} Year={Year} Product={forsikring.Product} Provider={forsikring.Provider} Stars={forsikring.Defaqto_Stjerne}/>}</>
          ))}
          {Product === "bat/fritidsbat" && data.allFritidsbatforsikring2020Csv.edges.map(({node: forsikring,i}) => (
            <>{forsikring.Defaqto_Stjerne === Stars.toString() && <GuideStarComponent key={i} Section={Product} Year={Year} Product={forsikring.Product} Provider={forsikring.Provider} Stars={forsikring.Defaqto_Stjerne}/>}</>
          ))}
          {Product === "bat/turbat" && data.allTurbatforsikring2020Csv.edges.map(({node: forsikring,i}) => (
            <>{forsikring.Defaqto_Stjerne === Stars.toString() && <GuideStarComponent key={i} Section={Product} Year={Year} Product={forsikring.Product} Provider={forsikring.Provider} Stars={forsikring.Defaqto_Stjerne}/>}</>
          ))}
        </div>
      </div>
    </div>
    )}
    />
)

export default GuideStarComponentRows

GuideStarComponentRows.propTypes = {
  Product: PropTypes.string,
  Stars: PropTypes.string,
  Year: PropTypes.string,
}

GuideStarComponentRows.defaultProps = {
  Product: ``,
  Stars: ``,
  Year: ``,
}